import { SELECIONAR_TIPOS_EMISSOES} from '../../actions/types';

const initialState = []

export default function reducerSelecionarTiposEmissoes (state = initialState, action ) {
  switch (action.type) {
    case SELECIONAR_TIPOS_EMISSOES: {
      return action.payload
    }

    default:
      return state
  }
}
